import { render } from "./home-welcome.vue?vue&type=template&id=21adaa06"
import script from "./home-welcome.js?vue&type=script&lang=js"
export * from "./home-welcome.js?vue&type=script&lang=js"

import "./home-welcome.vue?vue&type=style&index=0&id=21adaa06&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__